import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar.json';
import en from './locales/en.json';
import ml from './locales/ml.json';
import hi from './locales/hi.json'; // Corrected import if hi.json exists
import ms from './locales/ms.json';  // 
import mc from './locales/mc.json';

const resources = {
    en: { translation: en },
    ar: { translation: ar },
    ml: { translation: ml },
    hi: { translation: hi },
    ms: { translation: ms },
    mc: { translation: mc },

};

i18n
    .use(initReactI18next)
    .init({
        debug: true,
        resources,
        lng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;